import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';

export const RoutesAdmin = [
  {
    path: '/homeAdm',
    name: 'Home',
    icon: <HomeIcon />,
  },
];

export const RoutesUser = [
  {
    path: '/home-user',
    name: 'HOME',
    icon: <HomeIcon />,
  },
  // {
  //   path: '/visualizar-eventos',
  //   name: 'EVENTOS',
  //   icon: <EventNoteIcon />,
  // },
  {
    path: '/viewer/2',
    name: 'VISUALIZAR',
    icon: <SearchIcon />,
  },
];
